var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"16","height":"15","viewBox":"0 0 16 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0.984883 13.5256L7.91309 1.52564L14.8413 13.5256H0.984883Z","stroke":"#FA713F","fill":_vm.triangleFill}})])
}
var staticRenderFns = []

export { render, staticRenderFns }